import { render, staticRenderFns } from "./Works.vue?vue&type=template&id=f576e16c&scoped=true&"
import script from "./Works.vue?vue&type=script&lang=js&"
export * from "./Works.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f576e16c",
  null
  
)

export default component.exports